<script>
  import { beforeNavigate, afterNavigate } from "$app/navigation"

  import { posthog } from "$lib/services/logging.js"

  beforeNavigate(() => posthog.capture("$pageleave"))
  afterNavigate(() => posthog.capture("$pageview"))
</script>
